import { render } from "./LinkComponent.vue?vue&type=template&id=91f2e50a&scoped=true"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"

import "./LinkComponent.vue?vue&type=style&index=0&id=91f2e50a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f2e50a"]])

export default __exports__